// React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import Discount from "./Discount";
// Constants
import { DISCOUNTS_TABLE_HEADS } from "../../../configs/TableHeaderConstants";
import EntityConstants from "../../../configs/EntityConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Services
import { get } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
// import Filter from "./Filter";

const Discounts = () => {
    const permissions = usePermissions();
    const navigate = useNavigate();
    const spinService = SpinService();
    const [open, setOpen] = useState(false);
    const [id, setId] = useState(undefined);
    const [openFilter, setOpenFilter] = useState(false);
    const [filter, setFilter] = useState({
        sort: "id",
        order: "desc",
        max: 10,
        offset: 0,
        search: "",
        queryFilters: "{}"
    });

    const [discounts, setDiscounts] = useState({
        entries: [],
        total_count: 0
    });

    const onClose = () => {
        setOpen(false);
        setOpenFilter(false);
    };

    useEffect(() => {
        const fetchDiscounts = async () => {
            spinService.on();
            const response = await get(EntityConstants.DISCOUNTS, `sort=${filter.sort}&order=${filter.order}&max=${filter.max}&offset=${filter.offset + 1}&search=${filter.search}&queryFilters=${filter.queryFilters}`);
            const data = await response.json();
            setDiscounts(data);
            spinService.off();
        };
        !open && fetchDiscounts();
    }, [filter.sort, filter.max, filter.offset, filter.order, filter.search, filter.queryFilters, open]);

    useEffect(() => {
        if (!permissions.has(PermissionConstants.DISCOUNT_VIEW)) {
            navigate("/")
        }
    }, []);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Discounts
                    </Typography>
                    <div>
                        {permissions.has(PermissionConstants.DISCOUNT_CREATE) &&
                            <Button
                                variant="contained"
                                startIcon={<Iconify icon="eva:plus-fill" />}
                                onClick={() => { setId(undefined); setOpen(true) }}
                            >
                                New Discount
                            </Button>
                        }
                    </div>
                </Stack>
                <Card>
                    <GoTable
                        tableHeads={DISCOUNTS_TABLE_HEADS}
                        tableDatas={discounts.entries}
                        totalCount={discounts.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter((prevState) => {
                            return {
                                ...prevState,
                                sort: filter.sort,
                                order: filter.order,
                                max: filter.max,
                                offset: filter.offset,
                                search: filter.search,
                            }
                        })}
                        onView={(row) => { setId(row.id); setOpen(true) }}
                        openFilter={() => setOpenFilter(true)}
                        customFilter={false}
                    />
                </Card>
            </Container>

            {
                permissions.has(PermissionConstants.DISCOUNT_VIEW) && open && <GoDrawer
                    minwidth="70%"
                    title="Discount"
                    open={open}
                    onClose={() => onClose()}
                >
                    <Discount id={id} onClose={() => onClose()} />
                </GoDrawer>
            }

            {/* {
                openFilter && <Filter
                    queryFilters={filter.queryFilters}
                    openFilter={openFilter}
                    onClose={() => onClose()}
                    onFilters={(filterQuries) => setFilter((prevState) => { return { ...prevState, queryFilters: JSON.stringify(filterQuries) } })} />
            } */}

        </React.Fragment>
    );
}

export default Discounts;